export default __webpack_public_path__ + "static/media/MobileImg.f0543fc0.svg";